import Backbone from 'backbone';


class Model extends Backbone.Model {

	get idAttribute() {
		return 'name';
	}

}

export default Model;
